import { Helper } from '@/mixin/helper'
import store from '@/state/store'
import { setNavSource } from '@/helpers/navigation-guards'

export default [
  {
    path: '/fleet-task-instant/create',
    name: 'Fleet Task Instant Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess']([
          'fleet-task-instant:read',
          'fleet-task-instant:create',
          'fleet-task-instant:update',
          'fleet-task-instant:delete',
        ])) {
          next()
        } else {
          next({ name: '404' })
        }
      },
    },
    beforeEnter: setNavSource,
    component: () => import('@/router/views/fleet-task-instant/create-fleet-task-instant'),
  },
  {
    path: '/fleet-task-instant/detail/:id',
    name: 'Fleet Task Instant Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess']([
          'fleet-task-instant:read',
          'fleet-task-instant:create',
          'fleet-task-instant:update',
          'fleet-task-instant:delete',
        ])) {
          next()
        } else {
          next({ name: '404' })
        }
      },
    },
    beforeEnter: setNavSource,
    component: () => import('@/router/views/fleet-task-instant/detail'),
  },
  {
    path: '/fleet-task-instant/track/:data',
    name: 'Live Track Fleet Task Instant',
    meta: {
      guestPage: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        next()
      },
    },
    component: () => import('@/router/views/fleet-task-instant/live-track'),
  },
  {
    path: '/fleet-task-instant/import',
    name: 'Fleet Task Instant Import',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess']([
          'fleet-task-instant:read',
          'fleet-task-instant:create',
          'fleet-task-instant:update',
          'fleet-task-instant:delete',
        ])) {
          next()
        } else {
          next({ name: '404' })
        }
      },
    },
    component: () => import('@/router/views/fleet-task-instant/import/index.vue'),
  },
]
